"use client";

import React from "react";
import { useTranslations } from "@/lib/i18n-client";
import { track } from "@/lib/analytics";
import { Zap, Globe, Lock, Headset } from "lucide-react";

/**
 * Thin brutalist proof bar above the hero (compact trust).
 * Market-test: `proof_compact_v1` — compact, REAL/claim-safe proof
 * (market-test-plan.md §3/§8). Exposure only; consent-gated; `track` dedupes.
 */
const PROOF_EXPERIMENT_ID = "proof_compact_v1";

export default function ProofStrip() {
  const { t } = useTranslations();

  React.useEffect(() => {
    try {
      track({
        event_name: "proof_strip_viewed",
        event_id: `proof_strip_viewed:${PROOF_EXPERIMENT_ID}`,
        experiment_id: PROOF_EXPERIMENT_ID,
      });
    } catch {
      /* analytics is best-effort */
    }
  }, []);

  const items = [
    { icon: Zap, label: t("cobra.proof.delivery", "Instant QR delivery") },
    { icon: Globe, label: t("cobra.proof.coverage", "Coverage in 180+ countries") },
    { icon: Lock, label: t("cobra.proof.secure", "Secure Stripe checkout") },
    { icon: Headset, label: t("cobra.proof.support", "24/7 customer support") },
  ];

  return (
    <div className="bg-foreground text-background border-b-2 border-foreground">
      <div className="container mx-auto px-4 py-2 flex flex-wrap items-center justify-center gap-x-6 gap-y-1 text-xs sm:text-sm font-bold uppercase tracking-tight">
        {items.map(({ icon: Icon, label }, i) => (
          <span key={i} className="inline-flex items-center gap-1.5">
            <Icon className="w-3.5 h-3.5" />
            {label}
          </span>
        ))}
      </div>
    </div>
  );
}
